import { styled, css } from 'styled-components';

export const AppWrapper = styled.div<{ $hasBottomNavigation: boolean }>`
  padding-bottom: ${({ $hasBottomNavigation }) =>
    $hasBottomNavigation &&
    css`
      padding-bottom: var(--height-tab-navigation);
    `};
`;
